import React from 'react';
import { composer } from '../../component-decorators/composer';
import s from './empty-state.scss';
import { Divider, Text } from '@wix/design-system';
export const EmptyStateDivider = composer()
    .withTranslation()
    .compose(({ t }) => (React.createElement("div", { className: s.emptyStateDivider },
    React.createElement("div", { className: s.dividerWrapper },
        React.createElement(Divider, null)),
    React.createElement(Text, { className: s.emptyStateText, secondary: true }, t('manage-apps.empty-state.divider')),
    React.createElement("div", { className: s.dividerWrapper },
        React.createElement(Divider, null)))));
//# sourceMappingURL=empty-state-divider.js.map